// @flow
import {makeStyles} from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import {Link, useLocation} from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import {ButtonGroup, Grid, Hidden} from '@material-ui/core';
import CustomButton from '../../elements/CustomButton/CustomButton';
import {
  ArrowBack,
  HelpTwoTone,
  InfoOutlined,
  PlayCircleFilledTwoTone,
  Group,
} from '@material-ui/icons';
import {colors} from '../../assets/styles/colors';

// import ChatICon from '../../assets/img/chatIcon.png';

import AlertDueDateTier from '../tiers/components/AlertDueDateTier/AlertDueDateTier';

import type {User, Store} from '../../entities';
import type {Node} from 'react';
import CustomersContainer from '../crm/containers/CustomersContainer';
import {TIENDADA_LINKS} from '../../constants';
import MultichatContacts from '../multichat/contacts/components/multichat-contacts';
import CrmSegment from '../crm-segment/components/crm-segment';
import CrmCampaigns from '../crm-campaigns/components/crm-campaigns';

type MarketingSubRoute = {
  name: string | Node,
  path: string,
  component?: Node,
  icon: Node,
  disabled?: boolean,
  tierRestricted?: boolean,
};

type Props = {
  store: Store,
  user: User,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    background: '#f8f9fb',
  },
  navBackground: {
    [theme.breakpoints.down('sm')]: {
      background: 'white !important',
    },
  },
  icon: {
    height: '24px',
    width: '24px',
    marginRight: '8px',
    filter: 'brightness(0.5)',
  },
  content: {
    // flexGrow: 1,
    // paddingTop: 100,
    display: 'flex',
    flexDirection: 'column',
    // minHeight: '100%',
    // overflow: 'auto',
    padding: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  dividerVertical: {
    margin: theme.spacing(0, 1),
    background: colors.grey300,
  },
  contentBottom: {
    // flexGrow: 1,
    // paddingTop: 100,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    // height: '100%',
    // marginBottom: 64,
    background: '#f8f9fb',
    // overflow: 'auto',
    padding: theme.spacing(0, 4),
    [theme.breakpoints.down('sm')]: {
      marginBottom: 140,
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(0, 2),
    },
  },
  headerWrapper: {
    // background: '#f8f9fb',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
  },
  ayudaButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    margin: '0 14px 0 0',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      fontSize: '12px',
      margin: '0 16px 0 0',
      padding: 0,
      boxShadow: 'unset',
    },
  },
  tutorialsButton: {
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '4px 13px',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'unset',
      color: colors.purple3,
      padding: 0,
      boxShadow: 'unset',
    },
  },
  subRouteHeader: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: theme.spacing(2),
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    // textAlign: 'left',
    // justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  upsellMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      // flexDirection: 'column',
      padding: theme.spacing(1),
      flexWrap: 'wrap',
    },
    color: colors.purple3,
    background: colors.lightPurple,
    // opacity: 0.8,
    borderRadius: '12px',
    fontSize: '0.875rem',
  },
  upgradeTierButton: {
    marginLeft: 'auto',
    // backgroundColor: 'white',
    // color: colors.purple3,
    // padding: '4px 13px',
    // boxShadow:
    //   '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    backgroundColor: 'unset',
    color: colors.purple3,
    boxShadow: 'unset',
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(1),
      // backgroundColor: 'unset',
      // color: colors.purple3,
      // padding: 0,
      // boxShadow: 'unset',
    },
  },
  marketingButton: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    whiteSpace: 'pre-wrap',
  },
  disabledMarketingButton: {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    justifyContent: 'flex-start',
    backgroundColor: 'white',
    color: colors.grey800,
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
    whiteSpace: 'pre-wrap',
  },
  groupButton: {
    width: '100%',
    justifySelf: 'flex-end',
    backgroundColor: 'white',
    color: colors.purple3,
    padding: '20px 20px',
    marginBottom: theme.spacing(2),
    // justifyContent: 'flex-start',
    border: 'none',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
    borderRadius: '12px',
  },
  subRouteIcon: {
    fontSize: '1.5rem !important',
    margin: '0 12px',
  },
  subRouteNameWrap: {
    height: 56,
    position: 'sticky',
    top: 72,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    color: colors.grey700,
    backgroundColor: colors.grey200,
    padding: theme.spacing(2),
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  subRouteNameText: {
    fontWeight: 600,
    fontSize: '1.125rem',
    color: colors.grey900,
  },
  subRouteContent: {
    borderRadius: '12px',
    overflow: 'hidden',
  },
  labelButton: {
    alignItems: 'center',
  },
  startIcon: {
    fontSize: '1.5rem !important',
    marginRight: 12,
  },
  upsellMessageBottom: {
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    maxWidth: 670,
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
      bottom: 64,
      left: 0,
    },
    color: colors.purple3,
    background: colors.lightPurple,
    borderRadius: '12px',
    fontSize: '0.875rem',
  },
  subRouteSubtitle: {
    fontWeight: 400,
    fontSize: '16px',
    color: colors.grey600,
    margin: theme.spacing(1, 4),
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(2),
    },
  },
  subRouteTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  iconBack: {
    backgroundColor: 'white',
    padding: '4px',
    color: colors.grey600,
    marginRight: theme.spacing(1),
  },
}));

export default function Marketing(props: Props) {
  const classes = useStyles();
  const location = useLocation();

  const subRoutes: {[key: string]: MarketingSubRoute} = {
    crm: {
      name: 'CRM',
      path: '/customers',
      component: <CustomersContainer />,
      icon: <Group className={classes.startIcon} />,
      disabled: false,
      showSubtitle: true,
    },
    multichatContacts: {
      name: 'Contactos',
      path: '/contacts',
      component: <MultichatContacts />,
      icon: <Group className={classes.startIcon} />,
      disabled: false,
      showSubtitle: true,
    },
    segments: {
      name: 'Segmentos',
      path: '/segments',
      component: <CrmSegment />,
      icon: <Group className={classes.startIcon} />,
      disabled: false,
      showSubtitle: true,
    },
    campaigns: {
      name: 'Campañas',
      path: '/campaigns',
      component: <CrmCampaigns />,
      icon: <Group className={classes.startIcon} />,
      disabled: false,
      showSubtitle: true,
    },
  };

  const subRoutesArray = Object.keys(subRoutes).map(k => subRoutes[k]);

  const subRoute: ?MarketingSubRoute = subRoutesArray.find(
    (route: MarketingSubRoute) => location.pathname.startsWith(route.path)
  );

  return (
    <div className={classes.root}>
      <AlertDueDateTier />
      <Hidden mdUp>
        {subRoute ? (
          <>
            <div className={classes.subRouteNameWrap}>
              <CustomButton to="/marketing" className={classes.iconBack}>
                <ArrowBack />
              </CustomButton>

              <Typography
                component={'span'}
                className={classes.subRouteNameText}
              >
                {subRoute.name}
              </Typography>
            </div>
          </>
        ) : (
          <div className={classes.subRouteNameWrap}>
            <CustomButton to="/tools">
              <ArrowBack />
            </CustomButton>
            <Typography component={'span'} className={classes.subRouteNameText}>
              Regresar
            </Typography>
          </div>
        )}
      </Hidden>

      <main className={classes.content}>
        <Hidden smDown>
          <div className={classes.headerWrapper}>
            <Grid container justify="space-between" alignItems="center">
              <Grid item>
                <Typography className={classes.title}>
                  {subRoute ? subRoute.name : ''}
                </Typography>
              </Grid>
              <Grid item>
                <CustomButton
                  href={TIENDADA_LINKS.customerSupport.general}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.ayudaButton}
                  startIcon={<HelpTwoTone />}
                >
                  Ayuda
                </CustomButton>
                <CustomButton
                  href={TIENDADA_LINKS.youtube.main_channel}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.tutorialsButton}
                  startIcon={<PlayCircleFilledTwoTone />}
                >
                  Tutoriales
                </CustomButton>
              </Grid>
            </Grid>
          </div>
        </Hidden>
        {subRoute && subRoute.tierRestricted && (
          <div className={classes.upsellMessage}>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <InfoOutlined style={{marginRight: 16}} />
              Suscríbete a nuestros planes para acceder a funcionalidades PRO e
              impulsar tu negocio
            </div>
            <CustomButton
              className={classes.upgradeTierButton}
              to="/tiers-list"
            >
              Mejorar Plan
            </CustomButton>
          </div>
        )}
        {subRoutesArray.map((route: MarketingSubRoute, idx: number) => (
          <CustomButton
            key={idx}
            startIcon={route.icon}
            disabled={route.disabled}
            component={Link}
            to={route.path}
            className={`${
              route.disabled
                ? classes.disabledMarketingButton
                : classes.marketingButton
            } `}
          >
            {route.name}
          </CustomButton>
        ))}
      </main>
      <div className={classes.contentBottom}>
        <Hidden mdUp>
          <ButtonGroup>
            <CustomButton
              href={TIENDADA_LINKS.youtube.main_channel}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.groupButton}
              startIcon={<PlayCircleFilledTwoTone />}
            >
              Tutoriales
            </CustomButton>
            <CustomButton
              href={TIENDADA_LINKS.customerSupport.general}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.groupButton}
              startIcon={<HelpTwoTone />}
            >
              Ayuda
            </CustomButton>
          </ButtonGroup>
        </Hidden>
      </div>
    </div>
  );
}

Marketing.propTypes = {
  store: PropTypes.object,
  user: PropTypes.object,
};
